import { playerEventsStorage } from '../../storages';

export function handlePlayerPlaybackReset() {
  playerEventsStorage.clearIsPlayerPlaybackEnded();
}
